// Vendor imports
const Immutable = require('immutable')
const { createSelector } = require('reselect')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const IntoFeedItem = require('./components/feed-item')

function onContentCardClick() {
  businessEvents.trackSegment('into-content-card-click')
}

function renderIntoItemCard({ id, item }) {
  return (
    tag(IntoFeedItem, {
      key: id,
      href: item ? `/!${item.article['url_hash']}` : null,
      item,
      onClick: onContentCardClick
    })
  )
}

function createIntoItemCardFeedItem(item, index) {
  return {
    id: `into-item-card:${index}`,
    item,
    type: 'render',
    render: renderIntoItemCard
  }
}

const getItemCards = createSelector(
  state => state.feed.items,
  items => {
    return Immutable.List(
      [...items].map((item, index) => createIntoItemCardFeedItem(item, index))
    )
  }
)

const getEmptyItemCards = createSelector(
  () => {
    return Immutable.List(
      [...new Array(4)].map((item, index) => createIntoItemCardFeedItem(item, index))
    )
  }
)

module.exports = {
  getItemCards,
  getEmptyItemCards
}
